import React from "react";

import { Button, Radio, Typography } from "clearsense-ui/components";

const Transformations = ({ operations, setOperations }) => (
  <div className="space-y-4">
    <Typography style="h4" className="border-b-2">
      Normalization
    </Typography>
    <Radio stacked className="space-y-4">
      <Radio.Item
        label="Original structure"
        onChange={() => setOperations(false)}
        checked={operations === false}
        data-cy="original-structure-radio"
      />
      <Radio.Item
        label={
          <div className="flex space-x-2">
            <Typography className="self-center">Serialized JSON</Typography>
            <Typography className="text-xs text-gray-500 self-start">
              Map the JSON object to the types and format native to the
              destination.{" "}
              <Button
                label="Learn more"
                style="text"
                href="https://docs.airbyte.com/understanding-airbyte/connections#airbyte-basic-normalization"
                target="_blank"
                className="px-0 text-xs"
                rel="noopener noreferrer"
              />
            </Typography>
          </div>
        }
        onChange={() => setOperations(true)}
        checked={operations}
        data-cy="serialized-json-radio"
      />
    </Radio>
  </div>
);

export default Transformations;
